import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';

import SweetAlert from 'react-bootstrap-sweetalert';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

// Importamos la nueva acción 'toggleAreaEntryStrategy' junto a las demás
import {
  reorderAreaEntryStrategy,
  addAreaEntryStrategy,
  removeAreaEntryStrategy,
  toggleAreaEntryStrategy,
} from '../../store/actions';

import { entry_strategy_status } from '../../constants/entry_strategy_fields';

class EntryStrategyAreaList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      areasList: this.parseAreas(this.props.entryStrategyPositionList),
      deleteAreaModal: false,
      areaToDelete: null,
      addAreaModal: false,
      rcsAreaInput: '',
      showErrorAlert: false,
      errorMessage: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.entryStrategyPositionList !== this.props.entryStrategyPositionList) {
      this.setState({ areasList: this.parseAreas(this.props.entryStrategyPositionList) });
    }

    const { addAreaEntryStrategyError, loadingAddAreaEntryStrategy } = this.props;

    if (loadingAddAreaEntryStrategy === false && prevProps.loadingAddAreaEntryStrategy === true) {
      if (addAreaEntryStrategyError) {
        this.setState({
          showErrorAlert: true,
          errorMessage: addAreaEntryStrategyError,
        });
      }
    }
  }

  parseAreas(areasProp) {
    if (!areasProp) return [];
    try {
      const parsed = typeof areasProp === 'string' ? JSON.parse(areasProp) : areasProp;
      return Array.isArray(parsed) ? parsed.sort((a, b) => a.sortOrder - b.sortOrder) : [];
    } catch (e) {
      return [];
    }
  }

  moveArea(index, direction) {
    const { areasList, user } = this.state;
    const { strategyId, history } = this.props;

    const updatedList = [...areasList];
    const targetIndex = direction === 'up' ? index - 1 : index + 1;

    if (targetIndex < 0 || targetIndex >= updatedList.length) return;

    const temp = updatedList[index];
    updatedList[index] = updatedList[targetIndex];
    updatedList[targetIndex] = temp;

    const reorderedAreas = updatedList.map((area, idx) => ({
      ...area,
      sortOrder: idx + 1,
    }));

    this.setState({ areasList: reorderedAreas });

    const backendFormatAreas = reorderedAreas.map((area) => ({
      areaId: area.id,
      sortOrder: area.sortOrder,
    }));

    this.props.reorderAreaEntryStrategy({
      token: user.token,
      strategyId,
      areas: backendFormatAreas,
      history,
    });
  }

  handleDeleteArea() {
    const { areaToDelete, user } = this.state;

    this.props.removeAreaEntryStrategy({
      token: user.token,
      areaId: areaToDelete.id,
      history: this.props.history,
    });

    this.setState({ deleteAreaModal: false, areaToDelete: null });
  }

  // ==========================================
  // ALTERNAR ESTADO (TOGGLE)
  // ==========================================
  handleToggleArea(area) {
    const { user } = this.state;
    const { history } = this.props;

    // Si está '1' pasamos false (desactivar), si es cualquier otra cosa pasamos true (activar)
    const nextState = area.active !== '1';

    this.props.toggleAreaEntryStrategy({
      token: user.token,
      id: area.id,
      active: nextState,
      history,
    });
  }

  handleIdAddArea() {
    const { rcsAreaInput, areasList, user } = this.state;
    const { strategyId, history } = this.props;

    if (!rcsAreaInput.trim()) return;

    this.props.addAreaEntryStrategy({
      token: user.token,
      strategyId: strategyId.toString(),
      rcsArea: rcsAreaInput.trim(),
      sortOrder: (areasList.length + 1).toString(),
      history,
    });

    this.setState({ addAreaModal: false, rcsAreaInput: '' });
  }

  render() {
    const { t } = this.props;
    const { areasList, deleteAreaModal, addAreaModal, rcsAreaInput } = this.state;

    return (
      <>
        <Row className="mt-4">
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <CardTitle className="mb-0">{t('StrategyAreasRoute')}</CardTitle>
                  <Button
                    onClick={() => this.setState({ addAreaModal: true })}
                    color="secondary"
                    className="btn btn-primary waves-effect waves-light  usersButtons"
                  >
                    <i className="mdi mdi-plus mr-1"></i> {t('AddArea')}
                  </Button>
                </div>

                {areasList.length === 0 ? (
                  <div className="mt-4 text-muted">
                    <strong>{t('NoAreasAssignedYet')}</strong>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table className="table table-centered table-bordered table-hover mb-0">
                      <Thead className="thead-light">
                        <Tr>
                          <Th style={{ width: '100px' }} className="text-center">
                            {t('Order')}
                          </Th>
                          <Th>{t('AreaName')}</Th>
                          <Th style={{ width: '150px' }} className="text-center">
                            {t('Status')}
                          </Th>
                          <Th style={{ width: '220px' }} className="text-center">
                            {t('Actions')}
                          </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {areasList.map((area, index) => (
                          <Tr key={area.id || index}>
                            <Td className="text-center align-middle">
                              <Badge color="dark" className="p-2">
                                #{area.sortOrder}
                              </Badge>
                            </Td>
                            <Td className="align-middle font-size-15">{area.rcsArea}</Td>
                            <Td className="text-center align-middle">
                              <Badge
                                color={entry_strategy_status[area.active].color}
                                className={'badge-soft-' + entry_strategy_status[area.active].color + ' font-size-13'}
                                pill
                              >
                                {entry_strategy_status[area.active].name}
                              </Badge>
                            </Td>
                            <Td className="text-center align-middle">
                              {/* Subir */}
                              <Button
                                size="sm"
                                color="light"
                                className="mr-1"
                                disabled={index === 0}
                                onClick={() => this.moveArea(index, 'up')}
                              >
                                <i className="mdi mdi-arrow-up font-size-14"></i>
                              </Button>

                              {/* Bajar */}
                              <Button
                                size="sm"
                                color="light"
                                className="mr-2"
                                disabled={index === areasList.length - 1}
                                onClick={() => this.moveArea(index, 'down')}
                              >
                                <i className="mdi mdi-arrow-down font-size-14"></i>
                              </Button>

                              {/* ➔ BOTÓN DE TOGGLE */}
                              <Button
                                size="sm"
                                color={area.active === '1' ? 'secondary' : 'success'}
                                className="mr-2"
                                title={area.active === '1' ? t('Deactivate') : t('Activate')}
                                onClick={() => this.handleToggleArea(area)}
                              >
                                <i className="mdi mdi-power font-size-14" style={{ verticalAlign: 'middle' }}></i>
                              </Button>

                              {/* Eliminar */}
                              <Button
                                size="sm"
                                color="danger"
                                onClick={() => this.setState({ deleteAreaModal: true, areaToDelete: area })}
                              >
                                <i className="far fa-trash-alt font-size-14"></i>
                              </Button>
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </div>
                )}

                {/* MODAL ELIMINAR */}
                {deleteAreaModal && (
                  <SweetAlert
                    showCancel
                    title={t('AreYouSure')}
                    cancelBtnBsStyle="danger"
                    confirmBtnBsStyle="success"
                    confirmBtnText={t('ok')}
                    cancelBtnText={t('Cancel')}
                    onConfirm={() => this.handleDeleteArea()}
                    onCancel={() => this.setState({ deleteAreaModal: false, areaToDelete: null })}
                  >
                    {t('ThisActionWillRemoveTheAreaFromStrategy')}
                  </SweetAlert>
                )}

                {/* MODAL AGREGAR */}
                <Modal isOpen={addAreaModal} toggle={() => this.setState({ addAreaModal: false })}>
                  <ModalHeader toggle={() => this.setState({ addAreaModal: false })}>
                    {t('AddNewAreaToStrategy')}
                  </ModalHeader>
                  <ModalBody>
                    <FormGroup>
                      <Label for="rcsAreaInput">{t('AreaName')}</Label>
                      <Input
                        type="text"
                        id="rcsAreaInput"
                        placeholder="Ej: AREA_10"
                        value={rcsAreaInput}
                        onChange={(e) => this.setState({ rcsAreaInput: e.target.value })}
                      />
                    </FormGroup>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="danger" onClick={() => this.setState({ addAreaModal: false })}>
                      {t('Cancel')}
                    </Button>
                    <Button color="success" disabled={!rcsAreaInput.trim()} onClick={() => this.handleIdAddArea()}>
                      {t('Add')}
                    </Button>
                  </ModalFooter>
                </Modal>

                {/* POPUP ERROR */}
                {this.state.showErrorAlert && (
                  <SweetAlert
                    type="error"
                    title={t('Error')}
                    confirmBtnText={t('ok')}
                    onConfirm={() => this.setState({ showErrorAlert: false, errorMessage: '' })}
                  >
                    {this.state.errorMessage}
                  </SweetAlert>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { addAreaEntryStrategyError, loadingAddAreaEntryStrategy } = state.addAreaEntryStrategy || {};

  return {
    addAreaEntryStrategyError,
    loadingAddAreaEntryStrategy,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    reorderAreaEntryStrategy,
    addAreaEntryStrategy,
    removeAreaEntryStrategy,
    toggleAreaEntryStrategy, // ➔ CONECTADO AQUÍ
  })(withNamespaces()(EntryStrategyAreaList)),
);
